const COMPONENT_NAME = "locationselector";
export {
  COMPONENT_NAME
};
